import PropTypes from 'prop-types';
import cn from 'classnames';

import './AllBrandsResult.scss';
import { getSmartImage } from '../../helpers/helpers';

const numberFormatter = new Intl.NumberFormat();

const AllBrandsResult = props => {
  const { brand, selected, onSelect } = props;
  const logo = getSmartImage(brand.logo);

  return (
    <div className={cn('all-brands-results-row', brand.isArchived && 'all-brands-results-row--archived')}>
      <div />
      <div className='all-brands-results-info'>
        <div
          className={cn('all-brands-results-logo', !logo && 'all-brands-results-logo--missing')}
          onClick={() => {
            if (logo) window.open(logo, '_blank');
          }}
        >
          {logo && <img src={logo} />}
        </div>
        <p className='all-brands-results-name'>
          {brand.name}
          {!!brand.isArchived && <span className='all-brands-archived-badge'>Archived</span>}
          {!!brand.hideCrossBrandRecommendations && <span className='all-brands-hide-cross-brand-badge'>Hides other brands</span>}
        </p>
        <p className='all-brands-results-domains'>
          {brand.domain ? brand.domain : <span className='all-brands-error'>No domains</span>}
          {brand.altDomains.length ? `, ${brand.altDomains.join(', ')}` : ''}
        </p>
      </div>
      <div className='all-brands-results-cell'>{brand.industryName ?? 'No industry'}</div>
      <div className='all-brands-results-cell'>{numberFormatter.format(brand.numPromoting)}</div>
      <div className='all-brands-results-tags'>
        {brand.departments?.length ? brand.departments.map(({ Department_id, name }) => <span key={Department_id}>{name}</span>) : <p>No tags</p>}
      </div>
      <div className='all-brands-results-rankings'>
        {brand.industryRankings.length ? (
          brand.industryRankings.slice(0, 2).map(({ name, ranking }) => (
            <p key={name}>
              <span className='all-brands-results-rank'>#{ranking}</span> in {name}
            </p>
          ))
        ) : (
          <p>No rankings</p>
        )}
      </div>
    </div>
  );
};

AllBrandsResult.propTypes = {
  brand: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default AllBrandsResult;
